export interface IToast {
  type?: ToastType
  message?: string
  links?: ILink[]
}

export enum ToastType {
  Success,
  Error,
  Info,
  Warning,
}

export interface ILink {
  title: string
  link: string
}
